import { handleActions } from 'redux-actions';

import {
  LOGIN_USER,
  LOGOUT_USER,
  SET_CURRENT_USER,
  REGISTER_USER,
  RENEW_TOKEN,
  FORGOT_PASSWORD_VALIDATE_PROVIDER,
  FORGOT_PASSWORD_VALIDATE_TOKEN,
  FORGOT_PASSWORD_SEND_PIN_MAIL,
  FORGOT_PASSWORD_VALIDATE_PIN,
  REGISTER_USER_VALIDATE_PROVIDER,
  GET_TERMS_AND_CODITION,
  UPDATE_TERMS_AND_CODITION,
  SET_USER_DETAIL,
  RECAPTCHA_TOKEN,
} from '../constants/index';

const initialState = {
  isAuthenticated: false,
  isVisitor: true,
  authData: null,
  forgotPassword: {},
  registerUser: {},
  termsAndConditions: {},
  isCircle: false,
  recaptchaToken: null,
};

export const auth = handleActions(
  {
    [LOGIN_USER]: (state = initialState, action = {}) => ({
      ...state,
      isAuthenticated: action.payload?.statusCode === 200,
      ...action.payload,
    }),
    [SET_CURRENT_USER]: (state = initialState, action = {}) => ({
      ...state,
      isAuthenticated: action.payload?.statusCode === 200,
      ...action.payload,
    }),
    [SET_USER_DETAIL]: (state = initialState, action = {}) => ({
      ...state,
      authData: { ...state.authData, userDetail: action.payload },
    }),
    [LOGOUT_USER]: (state, action) => ({
      ...state,
      isAuthenticated: false,
      isVisitor: true,
      ...action.payload,
    }),
    [REGISTER_USER]: (state, action) => action.payload,
    [REGISTER_USER_VALIDATE_PROVIDER]: (state, action) => ({
      ...state,
      registerUser: {
        ...state.registerUser,
        providerState: action.payload,
      },
    }),
    [FORGOT_PASSWORD_VALIDATE_PROVIDER]: (state, action) => ({
      ...state,
      forgotPassword: {
        ...state.forgotPassword,
        providerState: action.payload,
      },
    }),
    [FORGOT_PASSWORD_VALIDATE_TOKEN]: (state, action) => ({
      ...state,
      forgotPassword: {
        ...state.forgotPassword,
        tokenValidationState: action.payload,
      },
    }),
    [FORGOT_PASSWORD_SEND_PIN_MAIL]: (state, action) => ({
      ...state,
      forgotPassword: {
        ...state.forgotPassword,
        pinMailState: action.payload,
      },
    }),
    [FORGOT_PASSWORD_VALIDATE_PIN]: (state, action) => ({
      ...state,
      forgotPassword: {
        ...state.forgotPassword,
        pinValidation: action.payload,
      },
    }),
    [RENEW_TOKEN]: (state, action) => ({
      ...state,
      authData: {
        ...state.authData,
        token: action.payload.newToken,
      },
    }),
    [UPDATE_TERMS_AND_CODITION]: (state = initialState, action = {}) => {
      state.authData.userHasAcceptedTerms = action.payload?.resultado === 'ok';
      return { ...state };
    },
    [GET_TERMS_AND_CODITION]: (state = initialState, action = {}) => ({
      ...state,
      termsAndConditions: action.payload,
    }),
    [RECAPTCHA_TOKEN]: (state = initialState, action = {}) => ({
      ...state,
      recaptchaToken: action.payload,
    }),
  },
  initialState,
);
